export const auth = { auth: true }
export const notConnected = { auth: false }



// WEBPACK FOOTER //
// ./src/router/metas.js